<neo-stepper [orientation]="'horizontal'" [linear]="true" [iconoEdicion]="'icon-16 icon-ibm--checkmark'"
  (selectionChange)="onCambioPaso($event)" #stepper>

  <mat-step [completed]="stepControlBusqueda" label="Evento">
    <div [id]="'cdk-step-contenido-0'"></div>
  </mat-step>

  <mat-step [stepControl]="stepControlDiaDelCumple" label="Día del cumple">
    <div [id]="'cdk-step-contenido-1'">
      <neo-notificacion #notificacionCalendario></neo-notificacion>
      <neo-calendario #calendario [permitirConfigurarCalendario]="false" [permitirDescargaPdf]=false
      [formularioGestionEventoDefecto]="false"   
      [permitirFiltrado]="false" [vista]="'month'" [permitirAltaEvento]="false" [configuracion]="configuracionCalendario"
        [deshabilitarDiasSinClaseEspecificada]="false" [mostrarHorarioEventoVistaMes]="false"
        [cerrarDialogoClickEvento]="false" [mostrarDiaSeleccionadoConEventos]="true" [botoneraAccionesCabecera]="[]"
        [eventos]="reservasDisponibles" (clickAccionCabeceraClick)="onNavegacionCalendario($event)"
        (clickEvento)="onClickTurnoDisponible($event)" (clickMomento)="onClickDia($event)">
      </neo-calendario>
      <div class="pie-calendario row" [ngClass]="{'selected': (reservaService.entidad$ | async)}">
        <div class="col-sm-4 col-xs-12">
          <div class="pie-tit">Día seleccionado:</div>
          <div class="pie-val">
            <ng-container *ngIf="(reservaService.entidad$ | async)?.fechaEvento;else sinDiaSeleccionado">
              {{auxiliarService.formatFecha((reservaService.entidad$ | async )?.fechaEvento, 'dd MMM yyyy') }}
            </ng-container>
            <ng-template #sinDiaSeleccionado>
              Selecciona en el calendario
            </ng-template>
          </div>
        </div>
        <div class="col-sm-8 col-xs-12">
          <neo-formulario #formStepControlDiaDelCumple [valoresIniciales]="reservaService.entidad$ | async"
            [camposFormulario]="formInputPaso2" [aplicarFlex]="true" [formularioAncho]="clasesFormularioAnchoEnum"
            (changeValueForm)="onCambioFormulario($event, 'formInputPaso2')">
          </neo-formulario>
        </div>
      </div>
    </div>
  </mat-step>

  <mat-step [stepControl]="stepControlDatosFiesta" label="Datos de la fiesta">
    <div [id]="'cdk-step-contenido-2'">
      <neo-notificacion #notificacionDatosFiesta></neo-notificacion>
      <neo-formulario #formStepControlDatosFiesta [valoresIniciales]="reservaService.entidad$ | async"
        [camposFormulario]="formInputPaso3" [aplicarFlex]="true" [formularioAncho]="clasesFormularioAnchoEnum"
        (changeValueForm)="onCambioFormulario($event, 'formInputPaso3')">
      </neo-formulario>
    </div>
  </mat-step>

  <mat-step [completed]="stepControlDatosContacto" label="Datos contacto">
    <div [id]="'cdk-step-contenido-3'">
      <neo-notificacion #notificacionDatosContacto></neo-notificacion>
      <neo-formulario #formStepControlDatosContacto [valoresIniciales]="reservaService.entidad$ | async"
        [camposFormulario]="formInputPaso4" [aplicarFlex]="true" [formularioAncho]="clasesFormularioAnchoEnum"
        (changeValueForm)="onCambioFormulario($event, 'formInputPaso4')" (accion)="onClickAccion($event)">
      </neo-formulario>
      <p>
        <neo-span-inner-html [contenido]="'reservar_datoscontacto_txt' | transloco"></neo-span-inner-html>
      </p>
    </div>
  </mat-step>

  <mat-step [completed]="stepControlPago" label="Pago">
    <div [id]="'cdk-step-contenido-4'">
      <p>
        <neo-span-inner-html
          [contenido]="'Introduce los datos de tu tarjeta para la entrega de la señal en concepto de reserva (50€)'"></neo-span-inner-html>
      </p>
      <ngx-stripe-card [elementsOptions]="elementsOptions"></ngx-stripe-card>
    </div>
  </mat-step>

  <mat-step [stepControl]="stepControlConfirmacion" label="Confirmación">
    <div [id]="'cdk-step-contenido-5'">
      <!-- Confirmación ok, ko-->
      <ng-container *ngIf="reservaService.esPagoCorrecto(); else procesoPagoKo">
        <img src="assets/images/reservar/pagoOk.svg" alt="" />
        <h2>Tu reserva ha sido finalizada <ng-container *ngIf="!errorEnvioEmailAccesoPagoOK">con éxito</ng-container>
        </h2>
        <p *ngIf="!errorEnvioEmailAccesoPagoOK; else procesoPagoOkErrorEnvioEmail">
          Te hemos enviado tu código de reserva al correo. Revísalo para gestionar tu reserva y añadir información sobre los
          menús e invitados o realizar alguna modificación.
        </p>
        <ng-template #procesoPagoOkErrorEnvioEmail>
          Ha ocurrido un error en el envio del código de reserva a tu email. Por favor, ponte en contacto con nosotros para
          proceder al reenvio del mismo.
        </ng-template>
        </ng-container>
        <ng-template #procesoPagoKo>
        <img src="assets/images/reservar/pagoKo.svg" alt="" />
        <h2>Algo no ha ido como debería...</h2>
        <p>
          Pero ha ocurrido un error y no se ha podido gestionar tu reserva. Por favor, vuélvelo a intentar para poder reservar tu
          fecha ideal.
        </p>
        </ng-template>
</div>
  </mat-step>

</neo-stepper>

<ng-template #dialogoCodigoDescuento>
  <neo-acciones-dialog #accionDialogCodigoDescuento
      [dialogTittle]="'Validar código de descuento'" [botonera]="[
      {
          label: 'Cancelar',
          id: 'btn-cancelar',
          tipoAccion: 'cerrar',
          basic: true,
          type: 'button',
          color: 'transparent',
          activo: true
      },
      {
          label: 'Validar',
          id: 'btn-confirmar',
          tipoAccion: 'accion',
          type: 'button',
          color: 'primary',
          activo: true,
          flat: true
      }
  ]" (accionBoton)="onAccionDialogoCodigoDescuento($event)" (cerrarDialogo)="onAccionDialogoCerrarCodigoDescuento()">
    <neo-notificacion #notificacionCodigoDescuento></neo-notificacion>
    <p>
      <neo-span-inner-html
        [contenido]="'Código descuento a aplicar sobre el importe final del paquete seleccionado'"></neo-span-inner-html>
    </p>
    <neo-formulario #formularioCodigoDescuento [valoresIniciales]="reservaService.entidad$ | async" [camposFormulario]="formInputCodigoDescuento"
      [aplicarFlex]="true"
      [formularioAncho]="clasesFormularioAnchoEnum" (changeValueForm)="onCambioFormulario($event, 'formInputCodigoDescuento')">
    </neo-formulario>
  </neo-acciones-dialog>
</ng-template>